import { connect } from 'react-redux';
import ContactsAccoladesSection from "../../../components/admin/riaContacts/acordionSections/ContactsAccoladesSection";
import ContactsForbesAumsSection
  from "../../../components/admin/riaContacts/acordionSections/ContactsForbesAumsSection";

const mapStateToProps = (state) => {
  return {
    session: state.adminLogin.adminUserSession,
  }
}

const ContactsForbesAumsSectionContainer = connect(mapStateToProps, {})(ContactsForbesAumsSection)

export default ContactsForbesAumsSectionContainer;